import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useField, useFormikContext } from "formik";

function RRDDirectDifferentExpToggleInput({
  name = "different_coupon_expiry",
  mailingDateFieldName = "mailing_date",
  backCouponExpiryFieldName = "back_coupon_expiry_date",
  expiryDateConstraints,
}) {
  const { setFieldValue } = useFormikContext();

  const [differentCouponExpiryField] = useField(name);
  const [mailingDateField] = useField(mailingDateFieldName);

  const handleOnDifferentCouponExpiryChange = (event) => {
    const { checked } = event.target;
    differentCouponExpiryField.onChange(event);
    // re-set back coupon date
    if (!checked) {
      setFieldValue(backCouponExpiryFieldName, null);
    } else {
      setFieldValue(
        backCouponExpiryFieldName,
        expiryDateConstraints?.defaultDate?.format("YYYY-MM-DD") || null
      );
    }
  };

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            {...differentCouponExpiryField}
            checked={differentCouponExpiryField.value}
            onChange={handleOnDifferentCouponExpiryChange}
          />
        }
        label="Select different expiration dates for front and back"
        slotProps={{
          typography: {
            fontWeight: 700,
          },
        }}
        disabled={!mailingDateField.value}
        sx={{ userSelect: "none" }}
      />
    </>
  );
}

export default RRDDirectDifferentExpToggleInput;
